module.exports = __webpack_public_path__ + "img/designer-empty@2x.ac1ab5c5.png";